import {
  Button,
  Table,
  Input,
  Row,
  Col,
  Modal,
  message,
  Typography,
  Flex,
  Card,
} from "antd";
import { useEffect, useRef, useState } from "react";
import Highlighter from "react-highlight-words";
import api from "../../API";
import {
  DeleteOutlined,
  SearchOutlined,
  EditOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import dayjs from 'dayjs';
import { Link} from "react-router-dom";

function SegmentList() {
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const user = JSON.parse(localStorage.getItem('user'));
  const [searchText, setSearchText] = useState("");
  const tableDataOnScreen = useRef([]);
  const columns = [
    {
      title: "Name",
      dataIndex: "segmentName",
      width: 300,
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: "#ffc069",
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ""}
          />
        ) : (
          text
        ),
    },
    {
      title: "No of Contacts",
      dataIndex: "quantity",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: "#ffc069",
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ""}
          />
        ) : (
          text
        ),
    },
    {
      title: "Created date",
      dataIndex: "createdDate",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: "#ffc069",
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ""}
          />
        ) : (
          text
        ),
    },
    {
      title: "Action",
      key: "action",
      width: 105,
      align: "center",
      render: (_, record) => (
        <Flex justify="space-around" align="center">
          <Link to={`/contacts/segments/edit/${record.key}`}>
            <Button type="primary" icon={<EditOutlined />}></Button>
          </Link>
          <Button
            type="primary"
            danger
            icon={<DeleteOutlined />}
            onClick={() => {
              Modal.confirm({
                title: "Confirm deletion",
                content: `Are you sure you want to delete this segment?`,
                onOk() {
                  delete_segment(record.key);
                  handleRemoveRow(record.key);
                },
                maskClosable: true,
              });
            }}
          ></Button>
        </Flex>
      ),
    },
  ];

  useEffect(() => {
    api.list_all_segments(user?.userId)
    .then((segments) => {
      setLoading(true);
      tableDataOnScreen.current = segments.map((segment) => {
        return {
          ...segment,
          key: segment.id,
          createdDate: dayjs(segment.createdDate).format("YYYY-MM-DD"),
        };
      });
      setDataSource(tableDataOnScreen.current);
      setLoading(false);
    })
    .catch((err) => message.error(err));
  }, []);

  function handleSearchInfo(e) {
    if (e.target.value === "") {
      setSearchText(e.target.value);
      setDataSource(tableDataOnScreen.current);
    } else {
      const searchData = tableDataOnScreen.current.filter((o) =>
        Object.keys(o)
          .slice(1)
          .some(
            (k) =>
              o[k] &&
              String(o[k]).toLowerCase().includes(e.target.value.toLowerCase())
          )
      );
      setSearchText(e.target.value);
      setDataSource(searchData);
    }
  }

  function delete_segment(id) {
    Promise.all([
      api.delete_segment(id),
      api.delete_segmentDetails(id),
      api.delete_contactsSegment(id),
    ])
    .then(() => message.success("Segment deleted successfully"))
    .catch((err) => message.error(err.message));
  }

  async function handleRemoveRow(removeKey) {
    setLoading(true);
    tableDataOnScreen.current = tableDataOnScreen.current.filter(
      (data) => data.key !== removeKey
    );
    setDataSource(tableDataOnScreen.current);
    setLoading(false);
  }

  return (
    <Card 
      style={{height: '100%', margin: "0 auto", boxShadow: "1px 1px 5px #ccc", borderRadius: 10 }}
      title={
        <Typography.Title level={5} style={{ margin: 0}}>
            Contact Segments
          </Typography.Title>
      }
      loading={loading}
      extra={
      <Link to={`/contacts/segments/new`}>
        <Button type="primary" style={{padding:15}} icon={<PlusCircleOutlined />}>
         New Segment
        </Button>
      </Link>}
    >
      <Row gutter={[16, 16]} align="middle">
        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
          <Input
            placeholder="Input search text"
            allowClear
            onChange={handleSearchInfo}
            suffix={<SearchOutlined />}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Table
            bordered
            scroll={{ x: 1000 }}
            columns={columns}
            style={{ marginTop: 16, width: "100%" }}
            dataSource={dataSource}
            loading={loading}
            pagination={{
              position: ["bottomCenter"],
              showSizeChanger: false, // Disable page size changer
              pageSize: 10, 
              showTotal: () => `Total: ${dataSource.length} items`
            }}
          />
        </Col>
      </Row>
    </Card>
  );
}

export default SegmentList;
